import { create } from "zustand";
import { UUID } from "../utils/typeDefinitions";

interface UserState {
    currentUserId: UUID | null;
    isUserLoaded: boolean;
    setCurrentUserId: (id: UUID | null) => void;
}

export const useUserStateStore = create<UserState>((set) => ({
    currentUserId: null,
    isUserLoaded: false,
    setCurrentUserId: (id) => set({ currentUserId: id, isUserLoaded: true }),
}));
